import ThermostatDevice from "../thermostat/thermostat";

interface Props {
  device: Device;
}
export default function AirConditionerDevice(props: Props) {
  return <ThermostatDevice device={props.device} mainMode="cool" />;
}
